import * as v from 'valibot';
import { attributeIdSchema, clusterIdSchema, endpointIdSchema, integerInRange } from '../../util/valibot';
import { attributeTypedValueSchema } from './AttributeTypedValue';
const reportingItemSchema = v.variant('type', [
    v.object({
        type: v.literal('reported'),
        endpoint_id: endpointIdSchema,
        cluster_id: clusterIdSchema,
        attribute_id: attributeIdSchema,
        min_seconds: integerInRange(0, 0xffff),
        max_seconds: integerInRange(0, 0xffff),
        change: v.optional(attributeTypedValueSchema),
    }),
    v.object({
        type: v.literal('received'),
        endpoint_id: endpointIdSchema,
        cluster_id: clusterIdSchema,
        attribute_id: attributeIdSchema,
        timeout: integerInRange(0, 0xffff),
    })
]);
export const reportingSchema = v.pipe(v.array(reportingItemSchema), v.transform((rs) => {
    var _a, _b;
    var _c, _d, _e;
    const endpoints = {};
    for (const r of rs) {
        (_a = endpoints[_c = r.endpoint_id]) !== null && _a !== void 0 ? _a : (endpoints[_c] = {});
        (_b = (_d = endpoints[r.endpoint_id])[_e = r.cluster_id]) !== null && _b !== void 0 ? _b : (_d[_e] = {});
        endpoints[r.endpoint_id][r.cluster_id][r.attribute_id] = r;
    }
    return endpoints;
}));
